import { Portal, Stack, Toast, createToaster, Toaster as ChakraToaster } from "@chakra-ui/react";

export const toaster = createToaster({
  placement: "top",
  pauseOnPageIdle: true,
});

export const Toaster = () => (
  <Portal>
    <ChakraToaster toaster={toaster} insetInline={{ mdDown: "4" }}>
      {(toast) => (
        <Toast.Root data-type={toast.type || "success"}>
          {toast.type === "success" && <Toast.Indicator></Toast.Indicator>}
          {toast.type === "error" && <Toast.Indicator></Toast.Indicator>}
          <Stack gap="1" flex="1" pt={0.5}>
            {toast.title && <Toast.Title>{toast.title}</Toast.Title>}
            {toast.description && <Toast.Description>{toast.description}</Toast.Description>}
          </Stack>
        </Toast.Root>
      )}
    </ChakraToaster>
  </Portal>
);
